export const environment = {
  production: true,
  buildId: '3560116082422531',
  configFile: 'config.json',
};
